import React from 'react';

import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField';

import ContentClearIcon from 'material-ui/svg-icons/content/clear';
import ActionSearchIcon from 'material-ui/svg-icons/action/search';


const iBtnStyle = {
  position: 'absolute',
  top: 6,
  minWidth: 60,
  height: 42,
  lineHeight: '42px',
  color: '#fff',
};


export default class MainAppBarSearch extends React.Component {

  constructor() {
    super();
    this.state = {
      searchTerm: '',
    }
  }

  componentDidMount(){
    this.searchElement.focus();
  }

  click(actionName, payload=null) {
    payload = payload || {};
    const { onAction } = this.props;
    onAction && onAction({...payload, name: 'click', target: actionName});
  }

  render() {
    const { searchTerm } = this.state;
    return (
      <div>
        <FlatButton
          icon={<ContentClearIcon />}
          labelPosition="after"
          label="CLOSE"
          backgroundColor="#FF3368"
          hoverColor="#FF3368"
          style={{...iBtnStyle, left: 10}}
          onTouchTap={e => {this.click('main-app-bar-search-close');}}
        />
        <TextField
          style={{position: 'absolute', left: 140, right: 100, width: 'auto', bottom: 0}}
          hintText="Type your search term here"
          inputStyle={{color: '#fff', fontSize: '26px'}}
          hintStyle={{color: '#fff', fontSize: '16px'}}
          ref={el => {
            this.searchElement = el;
          }}
          value={searchTerm}
          onChange={(e) => {this.setState({searchTerm: e.target.value});}}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.click(
                'main-app-bar-search-search', {value: searchTerm}
              )
            }
          }}
        />
        <FlatButton
          style={{...iBtnStyle, right: 10, width: 80}}
          icon={<ActionSearchIcon style={{fill: '#1AC6FF'}} />}
          backgroundColor="#fff"
          hoverColor="#fff"
          title="Search the feed"
          onTouchTap={e => {
            this.click(
              'main-app-bar-search-search', {value: searchTerm}
            )
          }}
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MainAppBar/MainAppBarSearch.jsx